import { Navigate } from "react-router-dom";
import { isGenericaToken, isTokenExpired } from "../services/Auth";

function RedirectRoute({ children, redirectTo }) {
  const Autenticado = isGenericaToken() && !isTokenExpired();
  return Autenticado ? <Navigate to={redirectTo} /> : children;
}

export default RedirectRoute;
